import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { ICompanyTypeApi } from "./base/companyTypeApi";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { CompanyTypeRequest } from "../models/request/companyTypeRequest";

const baseRoute: string = "CompanyType";

export class CompanyTypeApi extends ICompanyTypeApi {
	getDomain(request: CompanyTypeRequest | null): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getDomainPublic(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain_public`);
	}
}
